import { Box, styled } from "@mui/material";
import { alpha } from "@mui/material/styles";

import { MuiAccordion } from "@/orion/MuiComponents/MuiAccordion";
import { MuiAccordionDetails } from "@/orion/MuiComponents/MuiAccordionDetails";
import { MuiAccordionSummary } from "@/orion/MuiComponents/MuiAccordionSummary";

export const RecipientAccordion = styled(MuiAccordion)(({ theme }) => {
  const radius = theme.shape.borderRadiusMd;
  return {
    backgroundColor: theme.palette.background["paper-elevation-1"],
    boxShadow: "none",
    border: "1px solid transparent",
    overflow: "hidden",
    flexShrink: 0,
    // MUI Accordion only rounds top/bottom when :first-of-type / :last-of-type; override for standalone use.
    "&&": {
      borderTopLeftRadius: radius,
      borderTopRightRadius: radius,
      borderBottomLeftRadius: radius,
      borderBottomRightRadius: radius,
      "&:first-of-type": {
        borderTopLeftRadius: radius,
        borderTopRightRadius: radius,
      },
      "&:last-of-type": {
        borderBottomLeftRadius: radius,
        borderBottomRightRadius: radius,
      },
    },
    "&:before": {
      display: "none",
    },
    "&.Mui-expanded": {
      margin: 0,
    },
  };
});

export const RecipientAccordionSummary = styled(MuiAccordionSummary)(
  ({ theme }) => ({
    minHeight: 0,
    height: theme.spacing(10),
    padding: theme.spacing(0, 4),
    "& .MuiAccordionSummary-content": {
      margin: 0,
      alignItems: "center",
      justifyContent: "space-between",
      minWidth: 0,
    },
  }),
);

export const RecipientAccordionDetails = styled(MuiAccordionDetails)(
  ({ theme }) => ({
    borderTop: `1px solid ${alpha(theme.palette.tokens.outlines.defaultDividerDark, 0.1)}`,
    padding: theme.spacing(3, 4, 4),
  }),
);

export const RecipientSummaryLeading = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  columnGap: theme.spacing(3),
  minWidth: 0,
}));

export {
  RecipientTopBarChannelBadge,
  RecipientTopBarToggle,
  RecipientTopBarToggleButton,
} from "../channel/channelTopBar.styles";
